import { ref } from "vue";
import { defineStore } from "pinia";
import type { Category } from "@/models/category";
import { CategoryApiService } from "@/services/categoryApiService";

export const useCategoryStore = defineStore('categories', () => {
  // State
  const categoriesLoading = ref<boolean>(false);
  const categoriesLoaded = ref<boolean>(false);
  const categories = ref<Category[]>([]);

  // Getters
  function getCategoryByPlatformName(name: string): Category | null {
    for (const category of categories.value) {
      if (category?.platformName === name) {
        return category;
      }
    }
    return null;
  }

  // Actions
  async function fetchCategories() {
    if (categoriesLoaded.value || categoriesLoading.value) {
      return;
    }

    categoriesLoading.value = true;

    try {
      const response = await CategoryApiService.get();
      if (response?.data) {
        categories.value = response.data;
      } else {
        categories.value = [];
      }

      categoriesLoaded.value = true;
      categoriesLoading.value = false;
    } catch (e) {
      console.error(e);
      categoriesLoading.value = false;
    }
  }

  function $reset() {
    // Stub
  }

  return {
    categories,
    categoriesLoaded,
    getCategoryByPlatformName,
    fetchCategories,
    $reset
  };
});